import { useSetAtom, useAtom } from 'jotai';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { DevLocation, devicePathAtom } from '../atoms-types/devices';
import ConvertTime from '../converters/timestampConverter';
import { endpointLink } from '../../index';

export const useFetchDevicePath = (deviceEUI: string | null) => {
  const setDevicePath = useSetAtom(devicePathAtom);

  const { isFetching, isError, error } = useQuery({
    queryKey: ['devicePath', deviceEUI],
    staleTime: 1000 * 60 * 5, // Data is fresh for 5 minutes
    queryFn: async () => {
      if (!deviceEUI) return []; // Return an empty array if deviceID is null

      try {
        const response = await axios.get<DevLocation[]>(`${endpointLink}device-path/${deviceEUI}`);
        const data = response.data;
        UpdateDevicePath(data);
        return data;
      } catch (error) {
        console.error('Error fetching device path:', error);
        throw error;
      }
    },
    enabled: !!deviceEUI
  });

  function UpdateDevicePath(data: DevLocation[]) {
    const updatedDevicePath = data?.map(loc => ({
      ...loc,
      timestamp: ConvertTime(loc.timestamp)
    }));
    setDevicePath(updatedDevicePath);
  }

  return { isFetching, isError, error };
};







